import {
    PublicPriorityEmailAction,
    PublicPriorityEmailType,
    PublicPriorityReferralAction
} from "@therapprove/common";
import { DialogProps } from "../components/Dialog";

export const getDialogInitialState = (
    type: PublicPriorityEmailType,
    organizationName: string,
    patientName: string
): Partial<DialogProps> => {
    switch (type) {
        case PublicPriorityEmailType.PriorityOrganizationInvite:
            return {
                title: "You're one step closer to getting started!",
                description: `By accepting, you're allowing ${organizationName} to reach out and begin the conversation about care and next steps.`,
                icon: "heart_check",
                showAgreement: true,
                buttons: [
                    {
                        text: "Decline",
                        emailRecordAction:
                            PublicPriorityEmailAction.PriorityOrganizationInviteDecline
                    },
                    {
                        text: "Accept",
                        variant: "primary",
                        emailRecordAction:
                            PublicPriorityEmailAction.PriorityOrganizationInviteAccept
                    }
                ]
            };
        case PublicPriorityEmailType.PriorityGlobalInvite:
            const isTherapproveOrganization = organizationName
                .toLowerCase()
                .includes("therapprove");
            return {
                title: `Come join our Global Referrals List!`,
                description: `Great news! ${isTherapproveOrganization ? "Therapprove" : `Therapprove (partner with ${organizationName})`} has invited you to join their Global Referrals List! This means you'll still be working with ${organizationName} and also be visible to additional organizations partnering with ${isTherapproveOrganization ? "Therapprove" : organizationName}.`,
                icon: "globe",
                showAgreement: true,
                buttons: [
                    {
                        text: `Decline Invitation`,
                        emailRecordAction:
                            PublicPriorityEmailAction.PriorityGlobalInviteDecline
                    },
                    {
                        text: `Accept Invitation`,
                        variant: "primary",
                        emailRecordAction:
                            PublicPriorityEmailAction.PriorityGlobalInviteAccept
                    }
                ]
            };
        case PublicPriorityEmailType.PriorityReferralForCaregivers:
            return {
                title: `You've got a referral!`,
                description: `${organizationName} has referred ${patientName} to one or more organizations! By accepting this referral, ${patientName} will be added to the referral list for each organization for whom the referral is for.`,
                icon: "heart_check",
                showAgreement: true,
                buttons: [
                    {
                        text: "Decline",
                        referralAction:
                            PublicPriorityReferralAction.PriorityReferralForCaregiversDecline
                    },
                    {
                        text: "Accept",
                        variant: "primary",
                        referralAction:
                            PublicPriorityReferralAction.PriorityReferralForCaregiversAccept
                    }
                ]
            };
        default:
            return {
                title: "",
                description: "",
                icon: ""
            };
    }
};
